import PayoutsPanel from "@/components/PayoutsPanel";

export default function EarningsPayoutsPage() {
  return (
    <div className="p-6 lg:p-8 max-w-3xl" data-testid="earnings-payouts-page">
      <header className="mb-6">
        <div className="text-xs uppercase tracking-[0.3em] text-rose-500 mb-2">💸 Earnings</div>
        <h1 className="font-display text-3xl md:text-4xl">Earnings & Payouts</h1>
        <p className="text-sm text-zinc-500 mt-1">
          Every 18+ member who earns on My Panda X can get paid. Set up Stripe once —
          tips and shop income then flow to your bank automatically.
        </p>
      </header>
      <PayoutsPanel />
    </div>
  );
}
